import type { HVSInfoModel } from 'modules/map/types';

/** Chỉ cần phần flyTo của vietmapgl.Map — khai báo hẹp để test được bằng object giả. */
export interface FlyToCapableMap {
  flyTo: (options: { center: [number, number]; zoom: number; duration: number }) => void;
}

export const HVS_FOCUS_ZOOM = 14;
export const HVS_FLY_DURATION = 1000;

/**
 * Mở panel thông tin HVS rồi bay tới điểm HVS.
 *
 * Dùng CHUNG cho hai đường vào: marker HVS trên bản đồ và thẻ logo HVS ở góc phải
 * (ControllerButton). Trước đây chỉ thẻ logo có hành vi này, marker HVS không gắn handler nào nên
 * bấm vào không phản hồi — tách ra đây để không còn chỗ nào bị bỏ sót hay lệch hành vi.
 *
 * Lưu ý thứ tự toạ độ: API HVS trả `latitude` mang giá trị KINH ĐỘ và `longitude` mang giá trị VĨ
 * ĐỘ (tên field bị đảo ở nguồn), nên center của vietmapgl là [latitude, longitude]. Giữ nguyên
 * đúng thứ tự mà marker đang dùng để không lệch điểm.
 */
export const focusHvs = (
  map: FlyToCapableMap | null | undefined,
  dataHVS: Pick<HVSInfoModel, 'latitude' | 'longitude'>,
  openPanel: (open: boolean) => void
): void => {
  openPanel(true);
  map?.flyTo({
    center: [Number(dataHVS.latitude), Number(dataHVS.longitude)],
    zoom: HVS_FOCUS_ZOOM,
    duration: HVS_FLY_DURATION,
  });
};

export default focusHvs;
